import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import AlertIcon from '@tradera/blueprint/theme/icons2/alert.svg?jsx';
import { setItemNotReceived } from './feedbacks-actions';

const _ItemNotReceived = ({ dispatch, isItemNotReceived, transactionId }) => {
    const { t } = useTranslator();
    const checkboxId = `inr-checkbox-${transactionId}`;
    return (
        <div className="alert alert-info mb-0 mt-2">
            <div className="d-flex">
                <AlertIcon className={`icon icon-md mr-2`} />
                <h5>{t('leaveFeedback_inrHeading')}</h5>
            </div>

            <p>{t('leaveFeedback_inrText')}</p>
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={checkboxId}
                    onChange={() =>
                        dispatch(
                            setItemNotReceived(
                                transactionId,
                                !isItemNotReceived
                            )
                        )
                    }
                    checked={isItemNotReceived}
                />
                <label className="form-check-label" htmlFor={checkboxId}>
                    {t('leaveFeedback_reportNoDelivery')}
                </label>
            </div>
        </div>
    );
};
export const ItemNotReceived = React.memo(_ItemNotReceived);
